module.exports = __webpack_public_path__ + "static/media/selants.829926a7.svg";